function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dashboarda{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-391.711 -11250.111)"
}, /*#__PURE__*/React.createElement("path", {
  className: "dashboarda",
  d: "M413.682,11260.308a11.025,11.025,0,0,0-10.209-10.171,10.914,10.914,0,0,0-8.272,2.938,11.005,11.005,0,0,0-2.881,11.65,2.516,2.516,0,0,0,2.381,1.68h16.02a2.542,2.542,0,0,0,2.4-1.728A10.98,10.98,0,0,0,413.682,11260.308Zm-2.089,3.846a.928.928,0,0,1-.871.638H394.7a.9.9,0,0,1-.858-.6,9.387,9.387,0,0,1,8.861-12.47c.219,0,.439.007.66.022a9.389,9.389,0,0,1,8.229,12.406Z",
  transform: "translate(0 0.001)"
}), /*#__PURE__*/React.createElement("path", {
  className: "dashboarda",
  d: "M418.236,11272.517c-.028,0-.055,0-.083,0l-3.732-5.585a.806.806,0,0,0-1.341.9l3.732,5.584a1.579,1.579,0,1,0,1.424-.9Z",
  transform: "translate(-15.525 -12.039)"
}), /*#__PURE__*/React.createElement("path", {
  className: "dashboarda",
  d: "M405.205,11273.97a.806.806,0,0,0-1.109.266,7.971,7.971,0,0,0-1.175,4.172.806.806,0,0,0,1.613,0,6.356,6.356,0,0,1,.937-3.328A.807.807,0,0,0,405.205,11273.97Z",
  transform: "translate(-8.196 -17.357)"
}), /*#__PURE__*/React.createElement("path", {
  className: "dashboarda",
  d: "M425.23,11261.093a8.044,8.044,0,0,0-2.128.286.807.807,0,0,0,.429,1.556,6.377,6.377,0,0,1,8.073,6.145.806.806,0,0,0,1.613,0A8,8,0,0,0,425.23,11261.093Z",
  transform: "translate(-22.519 -8.029)"
}));

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16.294,
    viewBox: "0 0 22 16.294",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.e917c5c5.svg";
export { ForwardRef as ReactComponent };